import { FormLabel } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useTranslation } from "react-i18next";
import DependentQuestions from "../../DependentQuestions";
import Field from "@/components/Field";
import Fieldset from "@/components/Fieldset";
import VisualizationTypeSelect from "../../VisualizationTypeSelect";
import VariantsList from "./VariantsList";
import { isRequired } from "@/lib/form";
import { cfg } from "@/schemas/question/cfg";

interface QuestionCheckboxProps {
  index: number;
}

const QuestionCheckbox = ({ index }: QuestionCheckboxProps) => {
  const { t } = useTranslation();

  const translationKeys = {
    variant: "surveyEditor.checkboxType.variant",
    addVariant: "surveyEditor.checkboxType.addVariant",
    noVariantsFound: "surveyEditor.checkboxType.noVariantsFound",
  };

  return (
    <Fieldset>
      <Field
        name={`questions.${index}.cfg.minChecked`}
        label={t("surveyEditor.checkboxType.minChecked")}
        required={isRequired(cfg.shape.minChecked)}
        render={({ field }) => (
          <Input type="number" className="w-24" {...field} />
        )}
      />
      <Field
        name={`questions.${index}.cfg.maxChecked`}
        label={t("surveyEditor.checkboxType.maxChecked")}
        required={isRequired(cfg.shape.maxChecked)}
        render={({ field }) => (
          <Input type="number" className="w-24" {...field} />
        )}
      />
      <Field
        label={t("surveyEditor.visualization")}
        name={`questions.${index}.cfg.visualization`}
        required={isRequired(cfg.shape.visualization)}
        render={({ field }) => <VisualizationTypeSelect {...field} />}
      />
      <FormLabel>{t("surveyEditor.checkboxType.variants")}</FormLabel>
      <VariantsList
        name={`questions.${index}.cfg.variants`}
        translationKeys={translationKeys}
      />
      <DependentQuestions index={index} />
    </Fieldset>
  );
};

export default QuestionCheckbox;
